import { CustomStringParam, SchemaFilterType } from '@ui/src';

export const blacklistUsersColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'name',
    label: 'Full name',
    sortable: true,
  },
  {
    name: 'blacklistId',
    label: '',
    hidden: true,
  },
  {
    name: 'createdAt',
    label: 'Date created',
    sortable: true,
  },
  {
    name: 'lastUpdated',
    label: 'Date updated',
    sortable: false,
  },
];

export const blacklistUsersDefaultSorter = {};

export const blacklistUsersSchema = {
  name: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  blacklistId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  entityGUID: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};
